import Vue from "vue";

export const websocket = () => {
    let tk = localStorage.getItem('tk') || '';
    if (!tk) return;

    let reconnectTimer = null;
    let reconnectDelay = 3000;
    const maxReconnectDelay = 30000;

    function connect() {
        const ws = new WebSocket("wss://assignment-api.huabanshou.cn:2346");

        ws.onopen = function () {
            reconnectDelay = 3000;
        };

        ws.onmessage = function (e) {
            let data = JSON.parse(e.data);
            let sendData = loginData(tk);
            if (data.code != 200) {
                console.log("出错了", data);
                return;
            }
            data = data.data;
            switch (data.type) {
                case "onConnect":
                    console.log("建立连接");
                    ws.send(JSONToStr(sendData));
                    return;
                case "bindUid":
                    console.log("绑定成功");
                    return;
                case "waitAdminMerchant":
                    console.log("待审核商户信息");
                    Vue.prototype.playAudio();
                    return;
                case "waitAdminAccount":
                    console.log("待审核抖音信息");
                    Vue.prototype.playAudio();
                    return;
            }
            console.log(data);
        };

        ws.onclose = function () {
            scheduleReconnect();
        };

        ws.onerror = function () {
            console.warn("WebSocket 连接异常，稍后自动重连");
            ws.close();
        };
    }

    function scheduleReconnect() {
        if (reconnectTimer) return;
        reconnectTimer = setTimeout(() => {
            reconnectTimer = null;
            connect();
            reconnectDelay = Math.min(reconnectDelay * 1.5, maxReconnectDelay);
        }, reconnectDelay);
    }

    connect();
}
export const JSONToStr = (data) => {
    return JSON.stringify(data);
}

export const loginData = (token) => {
    return { token, login_type: 'backstage' }
}
